module.exports = __webpack_public_path__ + "static/media/rom22.dde76848.jpg";